"use client";

import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { useAuth, signInWithGoogle } from "@/lib/firebase/auth";

export default function LoginPage() {
  const router = useRouter();
  const { user, loading } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!loading && user) router.replace("/dashboard");
  }, [user, loading, router]);

  async function handleGoogle() {
    setSubmitting(true);
    setError(null);
    try {
      await signInWithGoogle();
      router.replace("/dashboard");
    } catch (e) {
      setError(e instanceof Error ? e.message : "Login failed");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <main className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-md rounded-2xl border bg-white p-8 shadow-sm">
        <h1 className="text-2xl font-bold text-brand-700">เข้าสู่ระบบ</h1>
        <p className="mt-2 text-sm text-slate-600">ระบบทวนสอบ มหาวิทยาลัยมหาสารคาม</p>

        <button
          onClick={handleGoogle}
          disabled={submitting || loading}
          className="mt-6 w-full rounded-md bg-brand-500 text-white py-3 hover:bg-brand-600 disabled:opacity-50 flex items-center justify-center gap-2"
        >
          {submitting ? "กำลังเข้าสู่ระบบ..." : (
            <>
              <svg width="18" height="18" viewBox="0 0 18 18">
                <path fill="#fff" d="M9 3.5c1.4 0 2.6.5 3.6 1.4l2.6-2.6C13.8.9 11.6 0 9 0 5.5 0 2.5 2 1 5l3 2.3C4.8 5 6.7 3.5 9 3.5z"/>
                <path fill="#fff" d="M17.6 9.2c0-.6-.1-1.2-.2-1.7H9v3.4h4.9c-.2 1.1-.8 2-1.7 2.6l2.7 2.1c1.6-1.5 2.7-3.7 2.7-6.4z"/>
              </svg>
              เข้าสู่ระบบด้วย Google
            </>
          )}
        </button>

        {error && (
          <div className="mt-4 rounded-md bg-red-50 border border-red-200 p-3 text-sm text-red-700">
            {error}
          </div>
        )}

      </div>
    </main>
  );
}
